export const shouldEnableWebpush = (state, country) =>
    state?.config?.head?.plp?.enableWebpush &&
    (!state?.config?.head?.plp?.webpushcountries || state?.config.head.plp.webpushcountries.includes(country.toLowerCase()));
